import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from 'react-icons/ai';
import styles from './CampaignsPaymentStatus.module.css';

const CampaignsPaymentStatus = () => {
    const { campaignIdentifier, paymentStatus, txnId } = useParams();

    const isSuccess = paymentStatus === 'success';

    return (
        <div className={styles.pageWrapper}>
            <motion.div
                className={styles.statusCard}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, ease: 'easeOut' }}
            >
                <div className={styles.iconWrapper}>
                    {isSuccess ? (
                        <AiOutlineCheckCircle size={80} className={styles.successIcon} />
                    ) : (
                        <AiOutlineCloseCircle size={80} className={styles.errorIcon} />
                    )}
                </div>
                <div className={styles.statusText}>
                    {isSuccess ? 'Payment Successful!' : 'Payment Failed'}
                </div>
                {txnId && (
                    <div className={styles.txnInfo}>
                        Transaction ID: <span>{txnId}</span>
                    </div>
                )}
                <motion.div
                    className={styles.buttonWrapper}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    <Link
                        to={`/communications/campaign/${campaignIdentifier}/launch`}
                        className={`${styles.actionButton} ${isSuccess ? styles.launchBtn : styles.retryBtn}`}
                    >
                        {isSuccess ? 'Launch Campaign' : 'Add Again'}
                    </Link>
                </motion.div>
            </motion.div>
        </div>
    );
};

export default CampaignsPaymentStatus;
